module.exports = __webpack_public_path__ + "static/media/10.799493d4.jpg";